import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';

const AccidentFormHistoryTableColumns = (): JSX.Element => (
  <SimpleTableRow header>
    <SimpleTableCell name="ACCIDENT" className="w-md-grow">
      Accidents
    </SimpleTableCell>
    <SimpleTableCell name="DATE_TIME">Date/Time</SimpleTableCell>
  </SimpleTableRow>
);

export default AccidentFormHistoryTableColumns;
